/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedContactDealerButton_user = {
    readonly " $fragmentRefs": FragmentRefs<"SharedContactDealerWrapper_user">;
    readonly " $refType": "PdpSharedContactDealerButton_user";
};
export type PdpSharedContactDealerButton_user$data = PdpSharedContactDealerButton_user;
export type PdpSharedContactDealerButton_user$key = {
    readonly " $data"?: PdpSharedContactDealerButton_user$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedContactDealerButton_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedContactDealerButton_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '21b649f52a68f21cd76c8eb476bcdf13';
export default node;
